import { useMemo } from "react";

import { TicketingFormCategory } from "@simplyk/common";

import { allowsMultipleMembershipsPerPurchase } from "../helpers/membershipMemberInfo";

import { RateOutput } from "@/common/types/trpc";

export interface MembershipMemberInfo {
  isEnabled: boolean;
  allowsMultipleMemberships: boolean;
}

export const useMembershipMemberInfo = ({
  formCategory,
  rates,
}: {
  formCategory: TicketingFormCategory;
  rates: RateOutput[];
}): MembershipMemberInfo => {
  return useMemo(() => {
    const isEnabled = formCategory === TicketingFormCategory.MembershipV2;

    return {
      isEnabled,
      allowsMultipleMemberships: isEnabled && allowsMultipleMembershipsPerPurchase(rates),
    };
  }, [formCategory, rates]);
};
